import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-402">
      <div className="max-w-5xl mx-auto" data-id="element-403">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-404">
          Lo que <span className="text-[#FFD700]" data-id="element-405">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-406">
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-407">
            <h3 className="text-[#FFD700] text-xl font-black mb-5" data-id="element-408">
              🥁 LOS 6 TOMOS
            </h3>
            <div className="space-y-4" data-id="element-409">
              <div className="flex items-center gap-3 text-white" data-id="element-410">
                <span className="text-xl" data-id="element-411">🟢</span>
                <div className="flex-1" data-id="element-412">
                  <span className="font-bold" data-id="element-413">
                    Tomo 1 — El Despegue: Fundamentos:
                  </span>
                  <span className="text-gray-300" data-id="element-414">
                    {' '}
                    Setup · Agarre · Pulso · Primer Groove de Rock · Fills
                    Básicos
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-415">
                <span className="text-xl" data-id="element-416">🟡</span>
                <div className="flex-1" data-id="element-417">
                  <span className="font-bold" data-id="element-418">
                    Tomo 2 — El Lenguaje: Rudimentos y Lectura:
                  </span>
                  <span className="text-gray-300" data-id="element-419">
                    {' '}
                    10 Rudimentos Esenciales · Lectura Rítmica · Funk / Blues /
                    Pop
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-420">
                <span className="text-xl" data-id="element-421">🟠</span>
                <div className="flex-1" data-id="element-422">
                  <span className="font-bold" data-id="element-423">
                    Tomo 3 — El Groove: Estilos:
                  </span>
                  <span className="text-gray-300" data-id="element-424">
                    {' '}
                    Jazz · Bossa Nova · Samba · Metal · Compases Irregulares ·
                    5/4 · 7/8
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-425">
                <span className="text-xl" data-id="element-426">🔴</span>
                <div className="flex-1" data-id="element-427">
                  <span className="font-bold" data-id="element-428">
                    Tomo 4 — La Técnica: Maestría:
                  </span>
                  <span className="text-gray-300" data-id="element-429">
                    {' '}
                    Técnica Moeller · Control Dinámico · Pies Avanzados ·
                    Orquestación · Solos
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-430">
                <span className="text-xl" data-id="element-431">🟣</span>
                <div className="flex-1" data-id="element-432">
                  <span className="font-bold" data-id="element-433">
                    Tomo 5 — La Banda: El Mundo Real:
                  </span>
                  <span className="text-gray-300" data-id="element-434">
                    {' '}
                    Tocar en Banda · Grabación · Repertorio · Improvisación ·
                    Show en Vivo
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-435">
                <span className="text-xl" data-id="element-436">⭐</span>
                <div className="flex-1" data-id="element-437">
                  <span className="font-bold" data-id="element-438">
                    Tomo 6 — El Profe: Tu Negocio:
                  </span>
                  <span className="text-gray-300" data-id="element-439">
                    {' '}
                    Planificador Anual · Sistema de Evaluación · Clases Grupales
                    · Precios · Retención
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#FFD700]/5 border border-[#FFD700]/30 rounded-2xl p-8 text-center" data-id="element-440">
          <h3 className="text-[#FFD700] text-xl font-black mb-6" data-id="element-441">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-442">
            <div className="flex items-start gap-2 text-left" data-id="element-443">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-444">✅</span>
              <span className="text-white text-sm" data-id="element-445">
                Planificador semanal completo listo para usar en clase
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-446">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-447">✅</span>
              <span className="text-white text-sm" data-id="element-448">
                Clases estructuradas con objetivo, ejercicio, variantes por
                nivel y tarea
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-449">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-450">✅</span>
              <span className="text-white text-sm" data-id="element-451">
                Sistema de niveles sincronizado 🟢🟡🔴 (Inicial / Intermedio /
                Avanzado)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-452">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-453">✅</span>
              <span className="text-white text-sm" data-id="element-454">
                Evaluación diagnóstica + evaluaciones por tomo con criterios de
                corrección
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-455">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-456">✅</span>
              <span className="text-white text-sm" data-id="element-457">
                Rúbricas completas con escala de 1 a 4 para cada habilidad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-458">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-459">✅</span>
              <span className="text-white text-sm" data-id="element-460">
                Fichas de seguimiento mensual por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-461">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-462">✅</span>
              <span className="text-white text-sm" data-id="element-463">
                Canciones originales ProfePack® listas para tocar en clase
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-464">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-465">✅</span>
              <span className="text-white text-sm" data-id="element-466">
                Checklist de egreso por tomo (¿está listo para avanzar?)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-467">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-468">✅</span>
              <span className="text-white text-sm" data-id="element-469">
                Certificados de nivel imprimibles para el alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-470">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-471">✅</span>
              <span className="text-white text-sm" data-id="element-472">
                100% adaptado a la realidad del profe de batería argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}